class PlpLoadMore extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-plp-load-more]');
    this.grid = document.getElementById('product-grid');
    this.countEl = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    this.nextUrl = this.dataset.nextUrl || '';
    this.sectionId = this.dataset.sectionId || '';
    this.total = parseInt(this.dataset.total, 10) || 0;

    if (!this.button) return;

    if (!this.nextUrl) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    event.preventDefault();
    if (!this.nextUrl || this.button.classList.contains('is-loading')) return;

    this.button.classList.add('is-loading');
    this.button.setAttribute('aria-disabled', 'true');

    const url = new URL(this.nextUrl, window.location.origin);
    if (this.sectionId) {
      url.searchParams.set('section_id', this.sectionId);
    }

    fetch(url.toString())
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newGrid = html.getElementById('product-grid');
        const newLoadMore = html.querySelector('plp-load-more');

        if (newGrid && this.grid) {
          Array.from(newGrid.children).forEach((item) => {
            // Never append a promo that is already in the grid (Load More safety net)
            if (item.classList.contains('plp-promo-card-item')) {
              const promoId = item.getAttribute('data-plp-promo-block');
              if (
                promoId &&
                this.grid.querySelector(`[data-plp-promo-block="${promoId}"]`)
              ) {
                return;
              }
            }
            this.grid.appendChild(item);
          });
        }

        if (newLoadMore && newLoadMore.dataset.nextUrl) {
          this.nextUrl = newLoadMore.dataset.nextUrl;
          this.dataset.nextUrl = this.nextUrl;
        } else {
          this.nextUrl = '';
          this.dataset.nextUrl = '';
          this.hidden = true;
        }

        this.updateCount();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-disabled');
      });
  }

  updateCount() {
    if (!this.countEl || !this.grid) return;

    const productItems = this.grid.querySelectorAll(
      ':scope > .grid__item:not(.plp-promo-card-item)'
    ).length;
    const total = this.total || productItems;
    const label = `Showing ${productItems} of ${total} Items`;

    this.countEl.textContent = label;

    const mobileCount = document.getElementById('ProductCount');
    if (mobileCount && mobileCount !== this.countEl) {
      mobileCount.textContent = label;
    }
  }
}

if (!customElements.get('plp-load-more')) {
  customElements.define('plp-load-more', PlpLoadMore);
}
